import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import ArrowIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";

const useStyles = makeStyles()((theme) => ({
  topBar: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "fixed",
    width: "100%",
    padding: 0,
    zIndex: 5,
    [theme.breakpoints.down("sm")]: {
      // top: '64px',
      height: "54px",
    },
    [theme.breakpoints.up("sm")]: {
      // top: '64px',
      height: "64px",
    },
  },

  topBarShim: {
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      height: "54px",
    },
    [theme.breakpoints.up("sm")]: {
      height: "64px",
    },
  },

  titleText: {
    position: "absolute",
    flexGrow: 1,
    fontWeight: 300,
    textAlign: "center",
    lineHeight: 1.2,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.1rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.5rem",
    },
    maxWidth: "calc(100% - 85px)",
  },

  titleInputContainer: {
    width: "calc(100% - 120px)",
    maxWidth: "600px",
    "&:before": {
      borderColor: `${theme.palette.primary.contrastText} !important`,
    },
  },

  titleInput: {
    color: "white",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.25rem",
    },
  },

  backButton: {
    position: "absolute",
    color: theme.palette.primary.contrastText,
    [theme.breakpoints.down("sm")]: {
      left: "5px",
    },
    [theme.breakpoints.up("sm")]: {
      left: "15px",
    },
  },

  editIcon: {
    color: theme.palette.primary.contrastText,
  },
}));

export default function TitleBar({
  title,
  setTitle = null,
  onBack = null,
  editMode = false,
  static: isStatic = true,
}: any) {
  const { classes } = useStyles();

  return (
    <Box>
      <AppBar
        position={isStatic ? "static" : "fixed"}
        className={classes.topBar}
      >
        {onBack && !editMode && (
          <IconButton
            className={classes.backButton}
            size="medium"
            aria-label="back"
            onClick={onBack}
          >
            <ArrowIcon fontSize="inherit" />
          </IconButton>
        )}
        {editMode ? (
          <Input
            className={classes.titleInputContainer}
            value={title}
            onChange={(event: any) => setTitle(event.target.value)}
            error={!title}
            inputProps={{ className: classes.titleInput }}
            fullWidth
            startAdornment={
              <InputAdornment position="start" className={classes.editIcon}>
                <EditIcon fontSize="small" />
              </InputAdornment>
            }
          />
        ) : (
          <Typography className={classes.titleText}>{title}</Typography>
        )}
      </AppBar>
      <Box className={classes.topBarShim} />
    </Box>
  );
}
